import { usePermissions } from "../../hooks/usePermissions";
import { useSubscription } from "../../hooks/useSubscription";
import { PRIVILEGES } from "../../utils/privileges";
import "./ListOptions.scss";
const ListOptions = ({ options, onClick }) => {
  const { hasPermission } = usePermissions();
  const { hasSubscription } = useSubscription();
  return (
    <ul className="list-options">
      {options?.map((item, index) => {
        return (
          item?.privilege &&
          hasPermission(item?.privilege) && (
            <li
              key={index}
              onClick={(e) => onClick(e, item)}
              className={`${hasSubscription(item?.privilege) ? "" : "disabled"}`}
            >
              {item.icon && (
                <img src={item.icon} className="peyeicon" alt={item.label} />
              )}
              <div>{item.label}</div>
            </li>
          )
        );
      })}
    </ul>
  );
};

export default ListOptions;
